import React, { useState } from "react";
import { Card, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";
import OrderInformationModal from "./modals/OrderInformationModal";

const Order = ({
  order,
  demoMode = false,
  setShowInfoModal,
  setSelectedOrder,
}) => {
  const { t } = useTranslation();

  return (
    <Card className="mb-3 bg-light cursor-grab border">
      <Card.Body className="p-3">
        <Table size="sm" className="my-2">
          <tbody>
            <tr>
              <th>{t("ID")}</th>
              <td>{order.id}</td>
            </tr>
            <tr>
              <th>{t("Name")}</th>
              <td>{order.name}</td>
            </tr>
            <tr>
              <th>{t("Creation Date")}</th>
              <td>{order.creationDate}</td>
            </tr>
            <tr>
              <th>{t("Execution Date")}</th>
              <td>{order.lastUpdateDate}</td>
            </tr>
            <tr>
              <th>{t("Created By")}</th>
              <td>{order.created_by}</td>
            </tr>
            <tr>
              <th>{t("More Information")}</th>
              <td>
                <FaInfoCircle
                  size={16}
                  onClick={() => {
                    setSelectedOrder(order.id);
                    setShowInfoModal(true);
                  }}
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default Order;
